import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { EMAIL_DESIGNER_FEATURE_GROUP } from './group';

export const EMAIL_DESIGNER_FEATURES = {
  ACCESS: {
    guid: '38aee486-2deb-49bb-a841-0f4d6d090001',
    name: 'email-designer:access',
    description: 'Access the Email Designer app',
    action: 'read',
    product: 'app',
    parentGuid: EMAIL_DESIGNER_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { EMAIL_DESIGNER_FEATURE_GROUP } from './group';

export const EMAIL_DESIGNER_MODULE: FeatureModule = {
  product: 'app',
  groups: [EMAIL_DESIGNER_FEATURE_GROUP],
  features: featureList(EMAIL_DESIGNER_FEATURES),
};
